import BaseModel from './base/BaseModel.model';

export default class Comentario extends BaseModel {

    public id: number = 0;
    public usuarioId: number | null = null;
    public titulo: string = "";
    public descripcion: string = "";
    public refEntityName: string = "";
    public refEntityId: number = 0;
    
    constructor(){
        super();
        this.init();
    }

    init(){
        this.id = 0;
        this.usuarioId = null;
        this.titulo = "";
        this.descripcion = "";
        this.refEntityName = "";
        this.refEntityId = 0;
    }
}